document.querySelectorAll('.cic-carousel-wrap').forEach(function (wrap) {
  var track = wrap.querySelector('.cic-track');
  var prevBtn = wrap.querySelector('.cic-nav--prev');
  var nextBtn = wrap.querySelector('.cic-nav--next');
  if (!track || !prevBtn || !nextBtn) return;

  function scrollAmount() {
    var item = track.querySelector('.cic-item');
    var gap = 28;
    return item ? item.offsetWidth * 3 + gap * 3 : 300;
  }

  function updateButtons() {
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateButtons);
  window.addEventListener('resize', updateButtons);
  updateButtons();
});
